import { render } from "./QuanLyPhep.vue?vue&type=template&id=52bb42d4&scoped=true"
import script from "./QuanLyPhep.vue?vue&type=script&lang=js"
export * from "./QuanLyPhep.vue?vue&type=script&lang=js"

import "./QuanLyPhep.vue?vue&type=style&index=0&id=52bb42d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bb42d4"]])

export default __exports__